import { type Lesson } from "@core/grades/types";
import { type BreadcrumbItem } from "@core/shared/types";
import { URLS } from "@core/shared/utils";
import { trans } from "@mongez/localization";

/**
 * Build lesson breadcrumbs while retaining every available catalog ancestor.
 *
 * @example
 * const breadcrumbs = getLessonBreadcrumbs(lesson);
 */
export function getLessonBreadcrumbs(lesson: Lesson): BreadcrumbItem[] {
  const category = lesson.category;
  const parentCategory = category?.parent;

  return [
    {
      text: lesson.grade.name,
      url: URLS.grades.view(lesson.grade),
    },
    lesson.subject
      ? {
          text: lesson.subject.name,
          url: URLS.subjects.view(lesson.subject),
        }
      : undefined,
    parentCategory
      ? {
          text: parentCategory.name,
          url: URLS.grades.viewCategory(parentCategory),
        }
      : undefined,
    category
      ? {
          text: category.name,
          url: URLS.grades.viewCategory(category),
        }
      : {
          text: trans("grades.uncategorized"),
          url: "",
        },
    {
      text: lesson.name,
      url: "",
    },
  ].filter((item): item is BreadcrumbItem => Boolean(item));
}
